import React from 'react';
import RevenueReport from './RevenueReport';
import RevenueReportMobile from './RevenueReportMobile';
import ResponsiveWrapper from '../../../components/common/ResponsiveWrapper';


const RevenueReportWrapper: React.FC = React.memo(() => {
  return (
    <>
      <ResponsiveWrapper
        mobileComponent={RevenueReportMobile}
        desktopComponent={RevenueReport}
      />
    </>
  );
});

RevenueReportWrapper.displayName = 'RevenueReportWrapper';

export default RevenueReportWrapper; 